import type { Nullish } from "~/@types/generics"

export function parseHexaColor(color: Nullish<string>): `#${string}` | null {
  if (!color) {
    return null
  }

  return color.startsWith(`#`) ? (color as `#${string}`) : `#${color}`
}
